import React from 'react';
import PropTypes from 'prop-types';
import SectionHeadline from '../section-headline/section-headline';
import LinkWithArrow from '../link-with-arrow/link-with-arrow';
import '../rule/rule';
import 'reset-css/reset.css';
import css from './chapter-list.css';

const ChapterList = ({
  indexUrl,
  sectionHeadline,
  sectionSubheadline,
  chapterList,
  selected,
  headlineType,
  ruleType,
}) => {
  // Maximum number of list items to display.
  const itemLimit = 8;

  return (
    <div className={css['ds-chapter-list']}>
      <SectionHeadline
        headline={sectionHeadline}
        subheadline={sectionSubheadline}
        rule={ruleType}
        type={headlineType}
        href={indexUrl}
      />
      {chapterList && (
        <ul>
          {chapterList.slice(0, itemLimit).map(({ text, href, id }, i) => (
            <li className={css['ds-chapter-list__item']} key={id}>
              <LinkWithArrow
                text={text}
                href={href}
                selected={selected === i}
                minor
              />
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

ChapterList.defaultProps = {
  sectionSubheadline: '',
  selected: null,
  indexUrl: null,
  headlineType: 'strong',
  ruleType: 'accent',
};

ChapterList.propTypes = {
  sectionHeadline: PropTypes.string.isRequired,
  sectionSubheadline: PropTypes.string,
  chapterList: PropTypes.arrayOf(
    PropTypes.shape({
      text: PropTypes.string,
      href: PropTypes.string,
      id: PropTypes.string,
    }),
  ).isRequired,
  /** The index position of the selected chapter list item. */
  selected: PropTypes.number,
  indexUrl: PropTypes.string,
  headlineType: PropTypes.string,
  ruleType: PropTypes.oneOf(['accent', 'emphasised', 'heavy']),
};

export default ChapterList;
